"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
const schema = {
    type: "object",
    properties: {
        rocDate: (0, common_1.makeAppointmentSchema)({
            disableFuture: true,
            isRequired: true,
        }),
        doctorName: { type: "string", title: "Doctor Name" },
        phoneNumberWithCountryCode: {
            type: "object",
            properties: {
                countryCode: {
                    type: "string",
                    oneOf: [
                        {
                            const: "+1",
                            title: "+1 United State",
                        },
                        {
                            const: "+91",
                            title: "+91 India",
                        },
                        {
                            const: "+63",
                            title: "+63 Philippines",
                        },
                    ],
                    title: "Country Code",
                },
                phoneNumber: {
                    type: "integer",
                    title: "Phone Number",
                },
            },
        },
        contactPerson: {
            type: "string",
            title: "Contact Person Name at Doctor's office",
        },
        nextDoctorVisit: {
            type: "number",
            format: "date",
            title: "Next Doctor Visit",
        },
        clinicianAppointment: (0, common_1.makeAppointmentSchema)({
            disablePast: true,
        }),
        services: {
            type: "object",
            properties: {},
            title: "Services",
        },
        notes: { type: "string", title: "Notes", maxLength: 3000 },
    },
    required: ["rocDate"],
};
exports.default = schema;
